import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import styled, {css} from 'styled-components';

const TIPS_SIDEBAR_WIDTH = 480;

export const Sidebar = styled.div<{
  open?: boolean;
}>`
  flex-shrink: 0;
  width: ${TIPS_SIDEBAR_WIDTH}px;
  display: flex;
  flex-direction: column;
  background: ${globals.THEME.bgSurfaceTint};
  padding: 32px 24px;
  ${props => css`
    transform: translate(${props.open ? 0 : -1 * TIPS_SIDEBAR_WIDTH}px);
    margin-right: ${props.open ? '0' : -1 * TIPS_SIDEBAR_WIDTH}px;
    transition:
      transform 0.2s ${props.open ? 'ease-out' : 'ease-in'},
      margin-right 0.2s ${props.open ? 'ease-out' : 'ease-in'};
  `}
`;

export const SidebarPage = styled.div<{active?: boolean}>`
  ${props => !props.active && 'display: none;'}
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 32px;

  // hide scrollbars
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const SidebarSectionHeader = styled.div<{
  alignItems?: string;
  main?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  ${props =>
    css`
      ${props.alignItems && `align-items: ${props.alignItems};`}
      ${!props.main && 'margin-top: 24px;'}
    `}

  p {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }
`;

export const SidebarSectionSubheader = styled.div`
  color: ${globals.THEME.textSecondary};
  margin-top: -4px;
  margin-bottom: 20px;
`;

export const SidebarCollapseButton = styled.div`
  position: relative;
  top: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: ${globals.THEME.textSecondary};
  border-radius: 20px;
  cursor: pointer;

  i {
    font-size: 24px;
  }

  &:hover {
    background: ${globals.THEME.bgHoverSolid};
  }
`;

export const SidebarTabs = styled.div`
  display: flex;
  width: 432px;
  margin-top: 16px;
  border-bottom: 2px solid ${globals.THEME.border};
`;

export const SidebarTab = styled.div<{active?: boolean}>`
  position: relative;
  top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  color: ${globals.THEME.textPrimary};
  ${props =>
    props.active &&
    css`
      font-weight: 600;
      border-bottom: 2px solid ${globals.THEME.textPrimary};
    `}
`;

export const SidebarExamples = styled.div`
  margin-bottom: 32px;
`;

export const SidebarExample = styled.div`
  display: flex;
  height: 104px;
  margin-bottom: 16px;
  color: ${globals.THEME.textPrimary};

  div {
    flex-grow: 1;
    flex-direction: column;
    padding: 18px 22px 18px 24px;
    line-height: 22px;

    div {
      padding: 0;
      &:first-child {
        font-weight: 600;
      }
    }
  }
`;

export const SidebarReportTile = styled(TargetBlank)`
  display: flex;
  height: 120px;
  margin: 6px 0px;
  background: ${globals.THEME.bgSurfaceRaised};
  border-radius: 3px;
  cursor: pointer;
  transition:
    transform 0.3s,
    box-shadow 0.3s;

  &:hover {
    transform: scale(1.005);
    box-shadow: 1px 1px 14px rgb(0 0 0 / 8%);
  }

  div {
    padding: 24px 16px;
    width: 312px;

    p {
      color: ${globals.THEME.textSecondary};
      font-size: 14px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin: 0;

      &:first-child {
        color: ${globals.THEME.textPrimary};
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 4px;
      }

      &:last-child {
        color: ${globals.THEME.textTertiary};
        margin-top: 12px;
      }
    }
  }

  img {
    width: 104px;
    height: 104px;
    border-radius: 3px;
    margin: 8px;
  }
`;

export const SidebarCollapsibleSection = styled.div<{expanded?: boolean}>`
  margin: 32px 0;

  & > * {
    padding-left: 28px;
    ${props => !props.expanded && 'display: none;'}
  }

  div {
    &:first-child {
      padding: 0;
      margin-bottom: 6px;
      display: flex;
      font-weight: 600;
      color: ${globals.THEME.textPrimary};

      i {
        width: 24px;
        cursor: pointer;
        font-size: 23px;
        margin-right: 4px;
      }
    }

    &:nth-child(2) {
      margin-bottom: 16px;
      line-height: 20px;
      font-weight: 400;
      color: ${globals.THEME.textSecondary};
    }
  }

  img {
    max-width: 344px;
  }
`;
